import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import {
  fetchReturnOrderDetails,
  updateReturnOrderStatus,
} from "../../services/Returns";
import { constants } from "../../theme/Variables";

const tableHeader = [
  "PRODUCT DETAILS",
  "PRODUCT PRICE",
  "RETURN REASON",
  "RETURN DESCRIPTION",
  "RETURN IMAGES",
  "RETURN STATUS",
  "ACTION",
];

const displayRows = [
  "product_details",
  "product_price",
  "return_reason",
  "return_description",
  "return_images",
  "return_status",
  "actions",
];

function EditReturn() {
  const { state } = useLocation();
  const openDialog = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [showCardDtailes, setShowCardDtailes] = useState(null);
  console.log(showCardDtailes, "showCardDtailesshowCardDtailesshowCardDtailes");

  useEffect(() => {
    handleFetchReturnsDetails();
  }, []);

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleFetchReturnsDetails = async () => {
    try {
      setIsLoading(true);
      const response = await fetchReturnOrderDetails(state?.returnOrderId);
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        let data = response?.data?.data;
        setShowCardDtailes(data[0]);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.data?.message);
      console.log(error, "Error in fetching return order details");
      setIsLoading(false);
    }
  };

  const handleUpdateStatus = async (item, status) => {
    try {
      const updatedReturnOrders = showCardDtailes?.returnOrders.map(
        (product) => {
          if (product?.productId === item?.productId) {
            return { ...product, returnOrderStatus: status };
          }
          return product;
        }
      );

      console.log(updatedReturnOrders, "updatedReturnOrders");

      const updatedShowCardDetails = {
        ...showCardDtailes,
        returnOrders: updatedReturnOrders,
      };
      setShowCardDtailes(updatedShowCardDetails);
      setIsLoading(true);

      const response = await updateReturnOrderStatus(showCardDtailes?._id, {
        returnOrders: updatedReturnOrders,
        orderId: showCardDtailes?.orderId,
      });
      setIsLoading(false);

      if (response.status === 200 || response.status === 201) {
        handleOpenSnackBar("success", response.data.message);
        handleFetchReturnsDetails();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error.data?.message || "An error occurred");
      console.log(error, "Error in handleUpdateStatus");
    }
  };
  const handleOpenDialog = (row) => {
    console.log(row, "rowrowrowrowrow");

    openDialog.current.openDialog(row);
  };
  const handleSuspend = () => {
    console.log("Suspend action triggered!");
    openDialog.current.closeDialog();
  };

  return (
    <NavigationDrawer>
      <CustomBar title={"RETURN ORDER DETAILS"} />
      <Loader isloading={isLoading} />

      <AppContainer>
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={showCardDtailes?.returnOrders || []}
          showPagination={true}
          showAdminMenu={true}
          handleUpdateStatus={handleUpdateStatus}
          openDialog={openDialog}
          handleSuspend={handleSuspend}
          handleOpenDialog={handleOpenDialog}
        />
      </AppContainer>
    </NavigationDrawer>
  );
}

export default EditReturn;
